import keys from '@debbie/common/dist/cache/keys.js';
import * as debtRegister from '@debbie/common/dist/debt-register/rki.js';
import { DocumentTypes, documentsWhichIsFoundations, } from '@debbie/common/dist/documents/index.js';
import { PaymentPlanStatus, getCurrentPaymentPlan, } from '@debbie/common/dist/economy/payment-plans/index.js';
import { Entity } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as documentsAPI from '@debbie/cortex/dist/api/documents.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useRegistriesByCaseId } from '@debbie/cortex/dist/debt-registries/index.js';
import { documentsEntity } from '@debbie/cortex/dist/documents/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePaymentPlansByCaseId } from '@debbie/cortex/dist/paymentPlans/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { errorNotification } from '../../utils/errors.js';
import { Button, Checkbox, DateInput, File, FileDropzone, MoneyInput, Select, } from '../index.js';
const TribunalDocument = (props) => {
    const [type, setType] = useState(null);
    const [date, setDate] = useState(new Date());
    const [amount, setAmount] = useState(null);
    const [signedDate, setSignedDate] = useState(new Date());
    const [signed, setSigned] = useState(false);
    const [document, setDocument] = useState(null);
    const dropzoneRef = useRef(null);
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const creditorLoadable = useCreditor(props.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const paymentPlansLoadable = usePaymentPlansByCaseId(props.kase.caseId);
    const paymentPlans = h.hasData(paymentPlansLoadable)
        ? paymentPlansLoadable.data
        : null;
    const debtRegistriesLoadable = useRegistriesByCaseId(props.kase.caseId);
    const debtRegistries = h.hasData(debtRegistriesLoadable)
        ? debtRegistriesLoadable.data
        : [];
    const paymentPlan = getCurrentPaymentPlan(paymentPlans);
    const canSave = type != null;
    const canBeSigned = type && documentsWhichIsFoundations.signingRequired.includes(type);
    const addDocument = useMutation((type) => documentsAPI.add(props.kase.caseId, type, Entity.Case, document, signed, canBeSigned && signed ? signedDate : undefined, date, undefined, { amount }), {
        onSuccess: () => {
            q.invalidate(keys.write.create(documentsEntity));
            props.onSubmit();
        },
        onError: (err) => errorNotification(lang, err, 'create', lang.errorEntities.document),
    });
    return (React.createElement(FileDropzone, { dropzoneRef: dropzoneRef, onChange: setDocument },
        React.createElement(Wrapper, null,
            React.createElement(Select, { onChange: (e) => {
                    setType(e.target.value === '' ? null : e.target.value);
                }, value: type },
                React.createElement("option", { value: "" }, lang.documents.selectType),
                Object.values(DocumentTypes)
                    .filter((type) => ![
                    DocumentTypes.OTHER,
                    DocumentTypes.COURT,
                    DocumentTypes.FOUNDATION,
                ].includes(type))
                    .map((type) => (React.createElement("option", { key: type, value: type }, lang.documentTypes[type] || type)))),
            React.createElement(DateWrapper, null,
                React.createElement(DateInput, { placeholder: lang.documents.createdAt, value: moment(date), allowNull: false, onChange: (d) => {
                        setDate(d.toDate());
                    } })),
            React.createElement(MoneyInput, { value: amount || null, allowNull: true, placeholder: lang.documents.amount, onChange: (c) => setAmount(c === null ? c : Math.abs(c)) }),
            canBeSigned && (React.createElement(React.Fragment, null,
                React.createElement(Checkbox, { placeholder: lang.documents.documentSignedCheckbox, checked: signed, onChange: (e) => {
                        setSigned(e.target.checked);
                    } }),
                signed && (React.createElement(DateWrapper, null,
                    React.createElement(DateInput, { placeholder: lang.documents.signedAt, value: moment(signedDate), allowNull: false, onChange: (d) => {
                            setSignedDate(d.toDate());
                        } }))))),
            React.createElement(Button, { size: "small", theme: "secondary", style: { display: 'block', marginBottom: '20px' }, onClick: () => {
                    // @ts-ignore
                    dropzoneRef.current?.open();
                } }, lang.misc.chooseFile),
            document && (React.createElement(File, { file: document })),
            React.createElement(Button, { loading: addDocument.isLoading, disabled: !canSave, onClick: () => {
                    if (type != null) {
                        const hasCreatedOrActivePaymentPlan = paymentPlan
                            ? [
                                PaymentPlanStatus.CREATED,
                                PaymentPlanStatus.ACTIVE,
                            ].includes(paymentPlan.status)
                            : false;
                        const autoDebtRegisterEnabled = debtRegister.isAutoDebtRegisterEnabled(tenant, creditor);
                        const autoRegisterInOpenRegistryEnabled = debtRegister.isAutoRegisterInOpenRegistryEnabled(tenant, creditor);
                        const autoMoveToOpenRKI = debtRegister.canMoveToOpen(debtRegistries || [], {
                            signedAt: canBeSigned && signed
                                ? signedDate.toISOString()
                                : undefined,
                            date: date.toISOString(),
                            type: type,
                            meta: { amount },
                            entityType: Entity.Case,
                        });
                        if (autoDebtRegisterEnabled &&
                            autoRegisterInOpenRegistryEnabled &&
                            autoMoveToOpenRKI &&
                            !hasCreatedOrActivePaymentPlan) {
                            if (confirm(lang.documents.autoRKIAddFoundation)) {
                                addDocument.mutate(type);
                            }
                        }
                        else {
                            addDocument.mutate(type);
                        }
                    }
                } }, lang.misc.save))));
};
export default TribunalDocument;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const DateWrapper = styled.div `
  width: 100%;
  display: flex;
`;
//# sourceMappingURL=TribunalDocument.js.map